export const RuppeeSign = `₹`
export const enabledRazorPay =["emi", "upi_asba"]
